import IterativeTraining from './onboarding/onboarding_steps/IterativeTraining';

export default function IterativeTrainingPage() {

  return (
    <IterativeTraining />
  )
}